const getStyles = () => {
  return {
    section: {
      padding: '80px 0',
      backgroundColor: 'rgba(0,0,0,0.03)',
      '@media (max-width: 768px)': {
        padding: '60px 0'
      }
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 20px'
    },
    title: {
      fontWeight: '700',
      fontSize: '48px',
      lineHeight: '1.2',
      textAlign: 'center',
      marginBottom: '24px',
      color: '#000000',
      '@media (max-width: 768px)': {
        fontSize: '36px'
      }
    },
    subtitle: {
      fontSize: '20px',
      textAlign: 'center',
      marginBottom: '64px',
      color: 'rgba(0,0,0,0.7)',
      maxWidth: '800px',
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    primaryText: {
      background:
        'linear-gradient(135deg, #0c5adb 0%, #3a8ef6 50%, #8a2be2 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      backgroundSize: '200% 200%',
      fontSize: '35px'
    },
    cardsContainer: {
      display: 'grid',
      gap: '24px',
      marginBottom: '48px',
      '@media (min-width: 768px)': {
        gridTemplateColumns: 'repeat(2, 1fr)'
      },
      '@media (min-width: 1024px)': {
        gridTemplateColumns: 'repeat(3, 1fr)'
      }
    },
    card: {
      border: 'none',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      transition: 'all 0.3s ease-in-out',
      '&:hover': {
        boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
        transform: 'translateY(-4px)'
      }
    },
    cardContent: {
      padding: '24px'
    },
    cardIcon: {
      width: '48px',
      height: '48px',
      borderRadius: '50%',
      background: 'linear-gradient(135deg, #4f46e5 0%, #38bdf8 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#fff',
      boxShadow: '0 10px 25px rgba(139,92,246,0.3)',
      marginBottom: '16px'
    },
    cardText: {
      fontSize: '18px',
      lineHeight: '1.6',
      color: '#000000'
    },
    quote: {
      fontSize: '20px',
      lineHeight: '1.6',
      textAlign: 'center',
      color: 'rgba(0,0,0,0.6)',
      fontStyle: 'italic',
      maxWidth: '800px',
      margin: '0 auto',
      padding: '24px 0'
    }
  };
};

export default getStyles;
